import React, { useRef } from 'react';

import { Namespace } from '../../../../translation/namespace';
import Form, { FormContainerModifier, FormContext } from '../../../../components/molecules/Form';

import InstantSearchComboBox from '../InstantSearchComboBox/InstantSearchComboBox';
import { GlobalDocumentIds } from '../../../../types/GlobalDocumentIds';
import { Tooltip, TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { Icons, SVG } from '../../../../components/atoms/SVG';
import IForm from '../../../../types/IForm';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

type InstantSearchFormProps = {
  model: IForm;
  trackingUrl: string;
  customAccessKey?: string;
};

export function InstantSearchForm({ model, trackingUrl, customAccessKey }: InstantSearchFormProps) {
  const { t } = useSonTranslation(Namespace.InstantSearch);
  const buttonRef = useRef(null);
  return (
    <Form
      id="instant-search"
      model={model}
      role="search"
      ariaLabel={t('headline')}
      method="GET"
      statusInvisible
      containerModifier={[FormContainerModifier.NO_PADDING, FormContainerModifier.WIDTH_100]}
      allowNavigationOnUnsavedChanges
    >
      <FormContext.Consumer>
        {({ inputs, onChange }) => (
          <div className="instant-search__element font-regular-11-11 instant-search--input">
            {/* if used correctly and wisely, accesskeys are a11y enhancement */}
            {/* eslint-disable-next-line jsx-a11y/no-access-key */}
            <InstantSearchComboBox
              id={GlobalDocumentIds.instantSearch}
              resetButton
              trackingUrl={trackingUrl}
              labelTitle={t('input.label')}
              name="q"
              suggestUrl={inputs.q.comboBoxUrl?.url || ''}
              required={inputs.q.required}
              labelHidden
              maxLength={inputs.q.constraints?.maxLength}
              modifierInput="form-input--instant-search"
              placeholder={t('input.placeholder')}
              validationMessage={t('input.validationMessage')}
              // Events
              onInput={event => onChange('q', event.target.value)}
              accessKey={customAccessKey}
            />
            <Tooltip attachTo={buttonRef} placement={TooltipPlacement.TOP_START} hideTooltipFromScreenReader>
              <button ref={buttonRef} type="submit" className="instant-search__button" title={t('buttonSubmit.title')}>
                <span className="invisible">{t('buttonSubmit.name')}</span>
                <SVG inverted svgSpriteId={Icons.SEARCH_MAGNIFIER} svgClass="instant-search__icon-search" />
              </button>
            </Tooltip>
          </div>
        )}
      </FormContext.Consumer>
    </Form>
  );
}
